import {Component, Input, OnInit} from '@angular/core';
import {CompositeFilterDescriptor} from '@progress/kendo-data-query';
import {FilterService} from '@progress/kendo-angular-grid';
import {Config, FieldDefine, FieldType, LanguagesService, SearchType} from '../../../../core';
import {GridFormComponent} from '../grid-form.component';


@Component({
  selector: 'gc-filter-pane',
  templateUrl: './filter-pane.component.html',
  styleUrls: ['./filter-pane.component.less']
})
export class FilterPaneComponent implements OnInit {

  constructor(private lang: LanguagesService) { }
  FieldTypeEnum = FieldType;
  dateFormat = Config.dateFormat;

  @Input() public filter: CompositeFilterDescriptor; // No need
  @Input() public filterService: FilterService; // No need
  @Input() public column: any; // No need
  @Input() public field: FieldDefine;
  @Input() public form: GridFormComponent;
  @Input() public serverSide = true;

  public arrayListItems: Array<{ text: string, value: number }> = [
    { text: this.lang.define.lib.include, value: SearchType.In },
    { text: this.lang.define.lib.exclude, value: SearchType.NotIn }
  ];

  public boolListItems: Array<{ text: string, value: number }> = [
    { text: '=', value: SearchType.Equal },
    { text: '<>', value: SearchType.NotEqual }
  ];

  public boolValueListItems: Array<{ text: string, value: number }> = [
    { text: '', value: null },
    { text: this.lang.define.lib.yes, value: 1 },
    { text: this.lang.define.lib.no, value: 0 }
  ];

  public stringListItems: Array<{ text: string, value: number }> = [
    { text: '=', value: SearchType.Equal },
    { text: '<>', value: SearchType.NotEqual },
    { text: this.lang.define.lib.contains, value: SearchType.Contains },
    { text: this.lang.define.lib.startWith, value: SearchType.StartWith },
    { text: this.lang.define.lib.endWith, value: SearchType.EndWith}
  ];

  public dateListItems: Array<{ text: string, value: number }> = [
    { text: this.lang.define.lib.between, value: SearchType.In },
    { text: this.lang.define.lib.outside, value: SearchType.NotIn }
  ];

  public ngOnInit(): void {
    if (this.serverSide) {
      this.doDummyFilter();
    }
  }

  private doDummyFilter(): void {
    const filters = [];
    filters.push({
      field: this.field.name,
      operator: 'contains',
      value: '@'
    });
    this.filterService.filter({
      logic: 'and',
      filters
    });
  }
}
